import Styled from "styled-components";

const LayoutWrap = Styled.div`
        code {
            font-family: ${({ theme }) => theme["font-stack"]};
        }
        h1 {
            font-family: ${({ theme }) => theme["font-stack"]};
        }
        h2 {
            font-family: ${({ theme }) => theme["font-stack"]};
        }
        h3 {
            font-family: ${({ theme }) => theme["font-stack"]};
        }
        h4 {
            font-family: ${({ theme }) => theme["font-stack"]};
        }
        h5 {
            font-family: ${({ theme }) => theme["font-stack"]};
        }
        h6 {
            font-family: ${({ theme }) => theme["font-stack"]};
        }
        .text-orange
        {
            color:${({ theme }) => theme["orange-color"]};
        }
        .text-orange:hover
        {
            color: ${({ theme }) => theme["orange-hover"]};
        }
        .btn-close {
            &:focus {
                box-shadow: inherit;
            }
        }
        .btn 
        {
            &.btn-orange {
                color: #fff;
                background-color: ${({ theme }) => theme["orange-color"]};
                border-color: ${({ theme }) => theme["orange-color"]};
                margin: 0 auto;
                font-size: 16px;
                &:hover {
                    color: #fff;
                    background-color: ${({ theme }) => theme["orange-hover"]};
                border-color:${({ theme }) => theme["orange-hover"]};
                }
            }
        }
        .main-panel{
            overflow-y: auto;
            overflow-x: hidden;
            height: calc(100vh - 70px);
            background: white !important;
        }

        .btn-grey {
            color: #212529;
            background-color: #e9ecef;
            border: 1px solid #ced4da;
            margin: 0 auto;
            font-size: 16px;
            &:hover {
                color: #212529;
            }
        }
        .form-check-input {
            &:checked {
                background-color: ${({ theme }) => theme["orange-color"]};
                border-color: ${({ theme }) => theme["orange-color"]};
            }
            &:focus {
                border-color: ${({ theme }) => theme["orange-color"]};
                outline: 0;
                box-shadow: inherit;
            }
            &:checked[type=radio] {
                &:focus {
                    border-color: ${({ theme }) => theme["orange-color"]};
                }
            }
            cursor: pointer;
            border: 2px solid #0c0c0c40;
        }
        .form-check-input[type=checkbox] {
            border-radius: 2px;
        }
        .card {
            border: 0 solid #dedede;
            border-radius: 8px;
        }
        .main-panel.topmenu {
            margin-left: 0px;
        }
        .main-panel {
            display: flex;
            flex-direction: column;
            min-width: 0;
            z-index: 11;
            padding: 15px;
            width: 100%;
            flex-grow: 1;
          }
        .page-body-wrapper {
            height: auto;
            overflow: hidden;
            overflow-y: hidden;
            padding-top: ${(props) => props.showNote ? "0px" : "50px"};
            display: flex;
            flex-direction: row;
            padding-left: 0;
            padding-right: 0;
        }
        .toggle {
            padding-top: 40px;
            padding-left: 5px;
            padding-right: 0;
            background: #fff;
            border: none;
        }
        .filter_menu_icon {
            border: 1px solid var(--orange-color);
        }
        .menu{
            color: var(--orange-color);
        }
        .touchArea{
            margin-right:1.25em;
        }
        .mobSideBar 
        {
            .main-panel {
                margin-left: 60px;
            }  

            .mobSideBar .sidebar.sidebarMain {
                width: 60px;
            }   
            .sidebarMain {
                .serchFieldMain {
                  margin: 0 17px;
                }
              }
              .sidebar {
                .nav {
                  .dropmenuitems {
                    .nav-link {
                      display: none;
                    }
                  }
                  .nav-link {
                    padding: 6px 10px 6px 17px;
                  }
                }
              }
            .sidebarMainLinks {
                width: 60px;
              }
              .sidebar.sidebarInerLinks {
                width: 60px;
              }
              .sidebar.sidebarMain {
                width: 60px;
              }
              .listArowIcon {
                display: none;
              }
              .navItemArrow {
                display: none;
              }
              .nav-link {
                span.dsktopView {
                  display: none;
                }
              }
        }    
        
        @media (max-width: 575px) {
            .main-panel {
                margin-left: 0;
            }
            .mobSideBar .main-panel {
                margin-left: 0;
            }
            .menu {
                width: 15px;
                height: 15px;
            }
            .sidebar {
                width: 0;
            }
            .toggle {
                padding-top: 40px;
                padding-left: 1px;
            }
            .mobSideBar .sidebar.sidebarMain {
                width: 0;
            }
            .mobSideBar .sidebarMainLinks {
                width: 160px;
            }
            .mobSideBar .sidebar.sidebarMain {

                width: 160px;
                z-index: 111;
            }
            .mobSideBar .nav-link span.dsktopView {
                display: inline-block;
            }
            .sidebarMain .serchFieldMain
                {
                    display: none;
                }
                .mobSideBar .sidebarMain .serchFieldMain {
                    display: inline-block;
                }
        }
`;

export default LayoutWrap;
